import { render, staticRenderFns } from "./ContactlistSidebar.vue?vue&type=template&id=a48aef5e&"
import script from "./ContactlistSidebar.vue?vue&type=script&lang=js&"
export * from "./ContactlistSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports